import React from "react";
import AuthProvider from "./src/context/auth";
import { BrowserRouter } from "react-router-dom";

export const wrapRootElement = ({ element }) => {
  return (
    <AuthProvider>
      <BrowserRouter>{element}</BrowserRouter>
    </AuthProvider>
  );
};